import { HttpClientPlugin } from '../types';
import { getBasicAuthCredentials } from '../../vercel/config';

export function createWithBasicAuthPlugin(): HttpClientPlugin {
  return {
    async beforeRequest(url, options) {
      const credentials = getBasicAuthCredentials();
      if (!credentials) {
        return { url, options };
      }

      const { username, password } = credentials;

      options.headers = new Headers(options.headers);
      options.headers.set('Authorization', `Basic ${btoa(`${username}:${password}`)}`);

      return { url, options };
    },
  };
}
